// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9-Fem","col":"styles_col__3isP3"};